module.exports = __webpack_public_path__ + "static/media/bottle-process4.2a8defb7.png";